(function () {
  'use strict';

  function initReviewsCarousel(root) {
    if (!root || root.dataset.rcInitialized === 'true') return;
    if (typeof window.Swiper === 'undefined') return;

    var swiperEl = root.querySelector('[data-rc-swiper]');
    if (!swiperEl) return;

    root.dataset.rcInitialized = 'true';

    var paginationEl = swiperEl.querySelector('.rc-dots');

    new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      centeredSlides: true,
      centeredSlidesBounds: true,
      spaceBetween: 14,
      grabCursor: true,
      // loop: true,
      watchOverflow: true,
      speed: 600,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous review',
        nextSlideMessage: 'Next review'
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
            // dynamicBullets: true,
            // dynamicMainBullets: 3
          }
        : false,
      breakpoints: {
        750: {
          spaceBetween: 20,
          slidesPerView: '4.6'
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.rc-section').forEach(initReviewsCarousel);
  }

  window.initReviewsCarousel = initReviewsCarousel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.rc-section') : null;
    if (root) initReviewsCarousel(root);
  });
})();